import React, { useState, useEffect } from "react";
import tw, { styled } from "twin.macro";

const Container = styled.span(({ $show }) => [
  tw`fixed bottom-36 cursor-pointer h-12 w-12 bg-gray-600 opacity-70 transition-all flex flex-col items-center justify-center rounded z-50`,
  $show ? tw`right-2.5` : tw`right-[-3.625rem]`,
]);

const Svg = styled.img`
  ${tw`w-5 h-5 mx-auto invert stroke-2`}
`;

const Text = styled.div`
  ${tw`text-xs text-white font-extrabold`}
`;

const Scroll = ({ showBelow }) => {
  const [show, setShow] = useState(showBelow ? false : true);

  const handleScroll = () => {
    if (typeof window === "undefined" || typeof document === "undefined") {
      return;
    }
    const footerHeight = document.querySelector("footer").scrollHeight;
    // hide button when scrolled to footer
    const bottomLimit =
      document.body.scrollHeight - window.innerHeight - footerHeight;
    if (window.pageYOffset > showBelow && window.pageYOffset < bottomLimit) {
      if (!show) setShow(true);
    } else {
      if (show) setShow(false);
    }
  };
  const handleClick = () => {
    if (typeof window !== "undefined") {
      window[`scrollTo`]({ top: 0, behavior: `smooth` });
    }
  };
  useEffect(() => {
    if (typeof window !== "undefined" && showBelow) {
      window.addEventListener(`scroll`, handleScroll);
      return () => window.removeEventListener(`scroll`, handleScroll);
    }
  });

  return (
    <Container $show={show} onClick={handleClick}>
      <Svg src="/img/svg/chevron_up.svg" alt="scroll_to_top" />
      <Text>TOP</Text>
    </Container>
  );
};

export default Scroll;
